import {AntibodyEnforcedSchemaRole} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import * as net from 'util/Net';

export interface BeginMigrateSchemaInput {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
}

export interface BeginMigrateSchemaResponse {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
}

export function beginMigrateSchema(input: BeginMigrateSchemaInput): Promise<BeginMigrateSchemaResponse> {
  return net.postJSONPromise({
    url: '/1/api/proteins/begin-migrate-schema',
    data: input,
  });
}
